import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import Plyr from 'plyr-react';
import { X } from 'lucide-react';
import styles from './css/ViewDocumentary.module.css';
import 'plyr-react/plyr.css';

const FullVideoModal = ({ video, onClose }) => {
  const playerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  
  // Check if device is mobile on component mount and on window resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Initial check
    checkMobile();
    
    // Add resize listener
    window.addEventListener('resize', checkMobile);
    
    // Cleanup
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  
  const videoOptions = {
    controls: [
      'play-large',  // The large play button in the center
      'restart',     // Restart playback
      'rewind',      // Rewind by the seek time (default 10 seconds)
      'play',        // Play/pause playback
      'fast-forward', // Fast forward by the seek time (default 10 seconds)
      'progress',    // The progress bar and scrubber for playback and buffering
      'current-time', // The current time of playback
      'duration',    // The full duration of the media
      ...(isMobile ? [] : ['mute', 'volume']), // Only show volume controls on desktop
      'captions',    // Toggle captions
      'settings',    // Settings menu
      'pip',         // Picture-in-picture (currently Safari only)
      'airplay',     // Airplay (currently Safari only)
      'fullscreen'   // Toggle fullscreen
    ],
    autoplay: false, // Changed from true to prevent auto-restart issues
    muted: false,
    seekTime: 10,
    disableContextMenu: false,
    hideControls: false, // Make controls always visible
    resetOnEnd: false, // Prevent auto-restart
    keyboard: { focused: true, global: true },
    tooltips: { controls: true, seek: true }
  };

  // Cleanup function to handle video player properly
  useEffect(() => {
    // Handle cleanup when component unmounts
    return () => {
      if (playerRef.current) {
        try {
          // Attempt to clean up the player instance
          const player = playerRef.current.plyr;
          if (player && typeof player.destroy === 'function') {
            player.destroy();
          }
        } catch (error) {
          console.error('Error cleaning up Plyr instance:', error);
        }
      }
    };
  }, []);

  return ReactDOM.createPortal(
    <div className={styles.videoModal}>
      <div className={styles.modalContent}>
        <button className={styles.closeButton} onClick={onClose}>
          <X size={24} />
        </button>
        <Plyr
          ref={playerRef}
          source={{
            type: 'video',
            sources: [
              {
                src: video.video_url,
                type: 'video/mp4',
              },
            ],
          }}
          options={videoOptions}
        />
      </div>
    </div>,
    document.body
  );
};

export default FullVideoModal;